import { Injectable } from "@angular/core";
import { CrudService } from "src/app/components/shared/cruds/crud.service";
import { TiposServicioDTO } from "src/app/models/tipo-servicio.dto";

@Injectable({ providedIn: "root" })
export class TiposServiciosService extends CrudService<TiposServicioDTO> {
  protected controller: string = "settings/tiposservicios/";
}
